<template>
    <password></password>
</template>

<style lang="sass">
/* CSSファイルの読み込み */
@import '../../../sass/auth/password-new/common.scss';
</style>

<script>
export default {
    components: {
        password: require('../../components/Password.vue').default
    }
};
</script>
